import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaErrorPage, WeaTools, WeaTable, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import Title from './Title';
import {formatData, NoRightCom} from '../../util/common';
//内容组件
class EContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabdata: props.edata.data,
            currentTab: props.edata.currenttab,
        }
        this.handleTabData = this.handleTabData.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(!isEqual(nextProps, this.props)){
            this.setState({
                tabdata: nextProps.edata.data,
                currentTab: nextProps.edata.currenttab,
            });
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps)
    }
    componentDidMount(){
        this.props.onRef(this);
    }
    handleTabData(tabid){
        const { params, isremembertab } = this.props.config;
        const { currentTab } = this.state;
        const tabdata_local = ls.getJSONObj('tabdata-' + params.eid + '-' + tabid);
        this.props.handleRefresh(this);
        this.setState({
            refresh: tabid !== currentTab,
            tabdata: tabdata_local == null ? {} : tabdata_local,
        });
        WeaTools.callApi('/api/portal/element/ecodeelementtab', 'POST', {...params, tabid}).then(result => {
            ls.set('tabdata-' + params.eid + '-' + tabid, result);
            if(tabid === this.state.currentTab){
                this.setState({
                    tabdata: result,
                });
                if(isremembertab){
                    let edata = ls.getJSONObj('edata-' + params.eid);
                    if(edata){
                        edata.currenttab = tabid;
                        edata.data = result;
                        ls.set('edata-' + params.eid, edata);
                    }
                }
            }
        });
    }
    render() {
        const { config, edata, handleRefresh, handleDelete, fontSizeMp } = this.props;
        const { tabdata, currentTab } = this.state;
        const { tabids, titles, esetting } = edata;
        const { boundID: ebaseid, moreUrl } = tabdata;
        let { fontStyle } = config.item;
        const {isHasRight, isSetting, item, params, synergyParams} = config;
        if(!isEmpty(fontSizeMp)) fontStyle = fontSizeMp;
        const { eid, contentview, style, custom = {} } = item;
        esetting.fontStyle = fontStyle;
        let {packagename, viewcompname} = custom;
        const cstyle = tabids && tabids.length > 1 && contentview.style && contentview.style.height ? {height: parseInt(contentview.style.height)-32+"px",overflow: "auto"} : {};
        try {
            if (moreUrl) {
                if (config.item.header && config.item.header.toolbar && config.item.header.toolbar.more) {
                    config.item.header.toolbar.more.morehref = moreUrl;
                }
            } else {
                config.item.header.toolbar.more = null;
            }
        } catch (e) {
        }
        let EContent = null;
        if (isHasRight) {
            if (!this.props.refresh ) {
                if(window.rewritePortalCusEle && typeof rewritePortalCusEle == 'function') {
                    const props = {...this.props};
                    const options = {
                        config,
                        fontSizeMp,
                        isSetting,
                        id:eid,
                        eid,
                        ebaseid,
                        params,
                        synergyParams
                    }
                    EContent = window.rewritePortalCusEle(props, options);
                }
                if (EContent == null && window[packagename] && window[packagename]['com'] && window[packagename]['com'][viewcompname]) {
                    const EContentTemp = window[packagename]['com'][viewcompname];
                    EContent = <EContentTemp {...this.props} config={config} fontSizeMp={fontSizeMp} isSetting={isSetting} id={eid} eid={eid} params={params} synergyParams={synergyParams}/>;
                }
            } else {
                EContent = <div style={{width: '100%', height: '60px'}}/>;
            }
        } else {
            EContent = <NoRightCom/>;
        }

        const _titleProps = {
            currentTab,
            config,
            titles,
            tabids,
            handleRefresh,
            handleDelete,
            status,
            fontSizeMp,
            tabwidth: esetting.tabwidth,
            methodvalue: esetting.methodvalue,
            handleTabData: this.handleTabData
        }
        return <div>
            <Title {..._titleProps}/>
            <div className="tabContant" id={`tabcontant_${eid}`} style={{height: cstyle.height}}>
                {EContent}
            </div>
        </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
        return ( <WeaErrorPage msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
EContent = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(EContent);
export default EContent;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/ecodeelement/EContent.js